// extracted by mini-css-extract-plugin
module.exports = {"row":"row___egEwx","seg":"seg___2yFh4","tab":"tab___DMRQU","tabActive":"tabActive___1g-km"};